import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-screen bg-gray-100" }
const _hoisted_2 = { class: "grid place-items-center mx-2 my-20 sm:my-auto" }
const _hoisted_3 = { class: "w-11/12 p-12 sm:w-8/12 md:w-6/12 lg:w-5/12 2xl:w-4/12 px-6 py-10 sm:px-10 sm:py-6 bg-white rounded-lg shadow-md lg:shadow-lg" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center font-semibold text-3xl lg:text-4xl text-gray-800" }, " Welcome to Sidekick ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.amazonCognito())),
          id: "submit",
          class: "w-full py-3 mt-10 bg-gray-800 rounded-sm font-medium text-white uppercase focus:outline-none rounded-lg bg-blue-700 hover:shadow-none"
        }, " Login with Amazon Cognito ")
      ])
    ])
  ]))
}